import React, { memo, useState } from "react";
import { string } from "prop-types";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { selectLabelers, selectReviewers } from "redux/members/selectors";
import { useSelector } from "react-redux";
import styles from "./style.module.scss";

function Member({ labelerUserId, reviewerUserId }) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const labelers = useSelector(selectLabelers);
  const reviewers = useSelector(selectReviewers);

  const labeler = labelers.find((labeler) => labeler.userId === labelerUserId);
  const reviewer = reviewers.find(
    (reviewer) => reviewer.userId === reviewerUserId
  );

  const handleCollapse = () => {
    setIsCollapsed((prevState) => !prevState);
  };

  return (
    <div className={styles.memberContainer}>
      <div
        className={styles.memberHeader}
        role="button"
        tabIndex="0"
        onKeyPress={() => {}}
        onClick={handleCollapse}
      >
        <button type="button">
          {isCollapsed ? <ChevronRight /> : <ExpandMore />}
        </button>
        <span>Member</span>
      </div>
      {!isCollapsed ? (
        <div className={styles.memberBody}>
          {labeler && (
            <div className={styles.memberRow}>
              <div className={styles.memberRole}>Labeler:</div>
              <div className={styles.memberName}>{labeler.fullName}</div>
            </div>
          )}
          {reviewer && (
            <div className={styles.memberRow}>
              <div className={styles.memberRole}>Reviewer:</div>
              <div className={styles.memberName}>{reviewer.fullName}</div>
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
}

Member.propTypes = {
  labelerUserId: string,
  reviewerUserId: string,
};

export default memo(Member);
